// source: pbtypes/vehicle/skills/action_key.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.skills.ActionKey', null, global);
goog.exportSymbol('proto.skills.ActionKey.Enum', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.ActionKey = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.ActionKey, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.ActionKey.displayName = 'proto.skills.ActionKey';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.ActionKey.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.ActionKey.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.ActionKey} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.ActionKey.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.ActionKey}
 */
proto.skills.ActionKey.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.ActionKey;
  return proto.skills.ActionKey.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.ActionKey} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.ActionKey}
 */
proto.skills.ActionKey.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.ActionKey.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.ActionKey.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.ActionKey} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.ActionKey.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.skills.ActionKey.Enum = {
  UNSPECIFIED: 0,
  TAKE_PHOTO: 1,
  SURFACE_SCAN_SKILL: 2,
  START_VIDEO: 3,
  STOP_VIDEO: 4,
  SWITCH_RECORDING_MODE: 5,
  TIMED_WAIT: 6,
  SEQUENCE: 7,
  SEQUENCE_CONFIG: 8,
  SEQUENCE_PRETAKEOFF: 9,
  SEQUENCE_UNTIL_FAILURE: 10,
  SEQUENCE_UNTIL_SUCCESS: 11,
  PARALLEL: 12,
  ORBIT_POI_ACTION: 13,
  TAKE_PANORAMA: 14,
  GOTO_WAYPOINT: 15,
  GOTO_GPS_WAYPOINT: 16,
  GOTO_NAV_WAYPOINT: 17,
  SET_OBSTACLE_AVOIDANCE: 18,
  INITIALIZE_GPS: 19,
  SUBJECT_DETECTED: 20,
  LOOPER: 21,
  WITHIN_DISTANCE: 22,
  INVERTER: 23,
  TOGGLE_PHOTO_INTERVAL_MODE: 24,
  WIFI_SCAN: 25,
  SPOOF_JOYSTICKS_INPUTS: 26,
  UPDATE_JOYSTICKS_SETTINGS: 27,
  UPDATE_SHAPE_MAP: 28,
  SPOOF_OBSTACLE: 29,
  SPOOF_DISTURBANCE_ACTION: 30,
  UPDATE_VEHICLE_SETTINGS: 31,
  WAIT_FOR_VEHICLE_STOP: 32,
  MODIFY_SIM_STATE_ESTIMATION: 33,
  GOTO_AND_ORBIT_POI: 34,
  ACQUIRE_GPS: 35,
  SET_FAULT_OVERRIDE: 36,
  E_LAND: 37,
  TRAJECTORY_INSPECT: 38,
  TOGGLE_TARGET_POINT_EXPOSURE: 39,
  TOGGLE_SEMANTIC_AIM: 40,
  SPOOF_BATTERY_LEVEL: 41,
  NCPG_CONTROL: 42,
  REGISTER_COMPLIMENTARY_ACTIONS: 43,
  TRACK_IN_PLACE: 44,
  GLOBAL_GRAPH_CONTROL: 45,
  OVERRIDE_GPS_QUALITY: 46,
  INIT_GLOBAL_MAP: 47,
  STOP_FOR_PHOTO_INSPECT: 48,
  SPOOF_INITIAL_GPS_HEADING: 49,
  TRACK_LANDING_PAD_REQUEST: 50,
  APRILTAG_SET_ID: 51,
  DOCK_GPS_ESTIMATOR: 52,
  G47_COMMAND_OVERRIDE: 53,
  REQUEST_TAKEOFF_PROFILE: 54,
  SET_DESIRED_GPS_SOURCE: 55,
  SPOOF_MANUAL_GPS: 56,
  WEATHER_ACTION: 57,
  SET_ZOOM: 58,
  MISSION_PLANNER_SERVICE_CONTROL: 59,
  SPOTLIGHT_ACTION: 60,
  SET_CAMERA_SETTINGS: 61,
  PARACHUTE_CONTROL: 62,
  NIGHTSENSE_ACTION: 63,
  SPOOF_MULTI_DRONE: 64,
  SET_MOVEMENT_COMMAND: 65,
  SPOOF_FLIGHT_ENVELOPE_LIMITS: 66,
  TURNTABLE: 67,
  WAIT_FOR_RTK: 68,
  WING_WAYPOINTS_COMMAND: 69,
  DANCING_DRONE: 70,
  WAIT_FOR_PRECISE_FAULT: 71,
  DANCING_DRONE_SPLINE: 72,
  SEND_DYNAMIC_SCENARIO: 73,
  GLOBAL_PLANNER_REQUEST: 74,
  TOGGLE_SUBJECT_DETECTION: 75,
  SPOOF_SUBJECT_SCENARIO: 76,
  SET_SUBJECT_FOLLOWER_SETTINGS: 77,
  SCOUT_ACTION: 78,
  SPOOF_TRACKING_DEVICE: 79,
  GEOFENCE_CONFIG: 80,
  SET_DESIRED_IMU_SOURCE: 81,
  SET_GNSS_SOLVER_QUALITY: 82,
  SPOOF_PHONE_UI_VARIABLES_ACTION: 83,
  PLAY_AUDIO: 84,
  DUMMY_ACTION: 85,
  TEST_DESIRED_VELOCITY_ACTION: 86,
  SET_GIMBAL_ORIENTATION: 87,
  UPDATE_DOCK_LOCATION_ACTION: 88,
  SEND_MOTION_COMMAND: 89
};

goog.object.extend(exports, proto.skills);
